export default "__VITE_ASSET__C4IxvVmL__"